import React, { useState } from 'react';
import closeEyesIcon from 'static/images/icons/close-eyes.svg';
import openEyesIcon from 'static/images/icons/open-eyes.svg';
import classlist from 'utils/classlist';
import './style.scss';

interface EyeSwitchProps {
    label: string;
    value: string;
    className?: string;
}

const EyeSwitch: React.FC<EyeSwitchProps> = ({ label, value, className }) => {
    const [closeEye, setCloseEye] = useState(true);

    const handleClick = () => {
        setCloseEye(c => !c);
    };

    return (
        <div className={classlist('eye-switch-root', className)} onClick={handleClick}>
            <img className="eye mr-1" src={closeEye ? closeEyesIcon : openEyesIcon} alt="" />
            <span>
                {label} {closeEye ? '******' : value}
            </span>
        </div>
    );
};

export default EyeSwitch;
